import { useContext } from "react";
import { GamesContext } from "./gameCatalog";
import { ConfigContext } from "./ConfigProvider";
import { LobbyConfigContext } from "./LobbyConfigProvider";

export const GamesProvider = ({ children }: { children: React.ReactNode }) => {
  const promoConfig = useContext<any>(ConfigContext);
  const lobbyConfig = useContext<any>(LobbyConfigContext);

  const orgUuid = promoConfig?.orgUuid || lobbyConfig?.orgUuid;

  return <GamesContext.Provider value={orgUuid}>{children}</GamesContext.Provider>;
};
